// Hook do pobierania szczegółów klienta handlowca – GET /sales-crm/clients/:id

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IResponse as IClientResponse } from 'api/endpoints/useGetClient';

/** Szczegóły klienta handlowca (alias – ten sam kształt co useGetClient) */
export type ITraderClient = IClientResponse;

const getTraderClient = (id: number): Promise<IClientResponse> =>
  axios.get(`/sales-crm/clients/${id}`);

export const useGetTraderClient = (
  id: number,
  options?: UseQueryOptions<IClientResponse, IError>
) =>
  useQuery<IClientResponse, IError>(
    ['sales-crm', 'client', id],
    () => getTraderClient(id),
    options
  );
